import { IconName } from 'src/components/atoms'
import { ENABLE_SEND_NOTIFICATION_ORG_CODES } from 'src/domain/org'
import { MemoAndNotificationType, UpdateStatusType } from './type'

const memoMap = {
  reportMemo: '補足事項',
  manageMemo: '管理者メモ(報告ごと)',
  tenantMemo: '管理者メモ(テナントごと)',
  isNotificationSent: 'メッセージ',
} satisfies Record<MemoAndNotificationType, string>

// 一覧テーブルのメモ列・精査画面と同じアイコンをフィルタ選択肢にも表示する
const memoIconMap = {
  reportMemo: 'memo',
  manageMemo: 'eye',
  tenantMemo: 'note2',
  isNotificationSent: 'exclamation',
} satisfies Record<MemoAndNotificationType, IconName>

export const getMemoTitle = (memo?: MemoAndNotificationType): string => {
  return memo ? (memoMap[memo] ?? '') : ''
}

export const getMemoIcon = (memo: MemoAndNotificationType): IconName => {
  return memoIconMap[memo]
}

export const getMemoOptions = (
  orgCode: string
): {
  label: string
  value: MemoAndNotificationType
  icon?: IconName
  isBlueIcon?: boolean
}[] => {
  const options: {
    label: string
    value: MemoAndNotificationType
    icon?: IconName
    isBlueIcon?: boolean
  }[] = [
    {
      label: getMemoTitle('reportMemo'),
      value: 'reportMemo',
      icon: getMemoIcon('reportMemo'),
    },
    {
      label: getMemoTitle('manageMemo'),
      value: 'manageMemo',
      icon: getMemoIcon('manageMemo'),
      isBlueIcon: true,
    },
    {
      label: getMemoTitle('tenantMemo'),
      value: 'tenantMemo',
      icon: getMemoIcon('tenantMemo'),
      isBlueIcon: true,
    },
  ]

  if (!ENABLE_SEND_NOTIFICATION_ORG_CODES.includes(orgCode)) {
    return options
  }

  options.push({
    label: getMemoTitle('isNotificationSent'),
    value: 'isNotificationSent',
    icon: getMemoIcon('isNotificationSent'),
  })
  return options
}

export const popupOptions: UpdateStatusType[] = [
  'revertReported',
  'bulkFinalize',
]
